import {AppInstallation} from 'common/constants';
const {appInstallation, cloud, basePath, userDomainRetpathTemplate} = window.YC;

export const isYaTeam =
    appInstallation === AppInstallation.Internal || appInstallation === AppInstallation.Anonymous;

const passportTlds = ['com', 'by', 'kz', 'com.tr', 'ru', 'ua'];
export function getHostPrefix() {
    const hostname = window.location.host;
    for (const tld of passportTlds) {
        if (hostname.endsWith(`.${tld}`)) {
            return tld;
        }
    }
    return 'ru';
}

export function getPassportHref(internal?: boolean) {
    return internal
        ? 'https://passport.yandex-team.ru'
        : `https://passport.yandex.${getHostPrefix()}`;
}

export const getUserDomainRetpath = (retpath: string) => {
    if (!userDomainRetpathTemplate) {
        return retpath;
    }
    return userDomainRetpathTemplate.replace('<retpath>', encodeURIComponent(retpath));
};

export const getAuthHref = ({
    redirectUrl,
    change,
    federationId,
}: {redirectUrl?: string; change?: boolean; federationId?: string} = {}) => {
    let retpath = redirectUrl;

    if (!retpath) {
        retpath = location.href;
    }

    if (userDomainRetpathTemplate) {
        retpath = getUserDomainRetpath(retpath);
    }

    if (cloud && !change) {
        let path = basePath + `_auth/login?redirectUrl=${encodeURIComponent(retpath)}`;
        if (federationId) {
            path += `&federationId=${federationId}`;
        }
        return path;
    }
    return `${getPassportHref(isYaTeam)}/auth?retpath=${encodeURIComponent(retpath)}`;
};
